import script from "./foot-contact.vue?vue&type=script&lang=ts&setup=true"
export * from "./foot-contact.vue?vue&type=script&lang=ts&setup=true"

import "./foot-contact.vue?vue&type=style&index=0&id=1a503acb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a503acb"]])

export default __exports__